import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthLayout from 'components/layouts/AuthLayout';
import ScrollToTop from 'components/common/ScrollToTop';
import LoginPage from 'pages/auth/LoginPage';
import ForgotPasswordPage from 'pages/auth/ForgotPasswordPage';
import routePaths from './route-paths';
import ResetPassword from 'pages/auth/ResetPassword';

export const authRoutes = [
  {
    path: routePaths.login,
    component: LoginPage,
  },
  {
    path: routePaths.forgotPassword,
    component: ForgotPasswordPage,
  },
  {
    path: routePaths.resetPassword,
    component: ResetPassword,
  },
];

const AuthRouter = () => (
  <AuthLayout>
    <ScrollToTop />
    <Routes>
      {authRoutes.map(({ path, component: C }) => (
        <Route key={path} path={path} element={<C />} />
      ))}
      <Route path="*" element={<Navigate to={routePaths.login} />} />
    </Routes>
  </AuthLayout>
);

export default AuthRouter;
